export default function Footer() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-background-50">911爆料网</span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                911爆料网是一站式吃瓜黑料内容聚合平台，每日更新最全最新的911吃瓜黑料事件、合集与视频，打造综合吃瓜黑料网站入口，服务全网吃瓜群众。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                  <i className="ri-vidicon-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-bold text-background-50 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                {[
                  { label: '首页', href: '#hero' },
                  { label: '常见问答', href: '#faq' },
                  { label: '读者热评', href: '#comments' },
                  { label: '焦点专题', href: '#carousel' },
                  { label: '主题索引', href: '#index' },
                ].map((item) => (
                  <li key={item.href}>
                    <a
                      href={item.href}
                      onClick={(e) => { e.preventDefault(); scrollToSection(item.href); }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-bold text-background-50 mb-4">热门话题</h3>
              <ul className="space-y-2.5">
                {['娱乐爆料', '网红翻车', '社会事件', '明星八卦', '最新合集'].map((topic) => (
                  <li key={topic}>
                    <a
                      href="#topics"
                      onClick={(e) => { e.preventDefault(); scrollToSection('#topics'); }}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {topic}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-bold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                更多合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-4">
                <a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); scrollToSection('#contact'); }}
                  className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-send-line"></i>
                  联系我们
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 911爆料网. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}